import { mapIds, mapObjectize } from 'cityads-v3/utils/apiUtils';

import {
  GET_WEBMASTER_TYPES,
  GET_WEBMASTER_TYPES_SUCCESS,
  GET_WEBMASTER_TYPES_FAIL,
} from "../actions/webmasterTypes";

const initialState = {
  webmasterTypes: [],
  webmasterTypesById: {},
};

export default function webmasterTypes(state = initialState, action = {}) {
  switch (action.type) {
    case GET_WEBMASTER_TYPES:
      return {
        ...state,
        isLoading: true,
      }

    case GET_WEBMASTER_TYPES_SUCCESS:
      const webmasterTypes = action.response.webmasterType || [];
      const webmasterTypesById = mapObjectize(webmasterTypes);
      return {
        ...state,
        webmasterTypes: mapIds(webmasterTypes),
        webmasterTypesById,
        isLoading: false,
        isLoaded: true,
      }

    case GET_WEBMASTER_TYPES_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
      }

    default:
      return state;
  }
}
